import styled from '@emotion/styled';
import comingImg from 'views/Aide/assets/coming.png';
import { useTranslate } from '@tolgee/react';
import { ChatServiceQrImg } from 'bizComponents/ChatServiceQrImg';
import { css } from '@emotion/css';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    height: 212px;
  }
  .title {
    color: #515359;
    font-size: 14px;
    margin-top: 24px;
    white-space: pre-line;
    text-align: center;
  }
`;
const TokopediaEmpty = () => {
  const { t } = useTranslate();

  return (
    <Container>
      <img src={comingImg} alt="coming" />
      <div className="title">{t('tokopedia.remove.tips')}</div>
      <div
        className={css`
          width: 90%;
          margin: 20px auto 0 auto;
          display: flex;
          justify-content: center;
          padding: 30px 10px;
          background: #f7f9fa;
        `}
      >
        <ChatServiceQrImg />
      </div>
    </Container>
  );
};

export default TokopediaEmpty;
